import { DatePicker } from '@/app/core/components/DatePicker';
import {
  Box,
  FormControl,
  Grid,
  GridItem,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
} from '@chakra-ui/react';
import { Select } from '@ssar-app/uikit';
import { USAAParameters } from '@ssar-app/domain';
import { Controller, UseFormMethods } from 'react-hook-form';
import dayjs from 'dayjs';

interface paramOptions {
  runTypeOptions: string[];
  strategyTypeOptions: string[];
  BureauCallIndOptions: string[];
}
export interface ParameterProps {
  formMethods: UseFormMethods<USAAParameters>;
  model: Partial<USAAParameters>;
  paramOptions: paramOptions;
  setModel: (model: Partial<USAAParameters>) => void;
}

export const commonMandatoryParams = (props: ParameterProps) => {
  const { errors, control } = props.formMethods;

  return (
    <>
      <Box>
        <FormControl isRequired isInvalid={!!errors.runType} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Run Type :</FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='runType'
                defaultValue={
                  props.model?.runType || props.paramOptions.runTypeOptions[0]
                }
                control={control}
                render={({ value, onChange }) => (
                  <Select
                    placeholder='Run Type'
                    options={props.paramOptions.runTypeOptions.map((val) => ({
                      label: val,
                      value: val,
                    }))}
                    defaultValue={props.model?.runType || value}
                    optionLabelProps={{ color: 'black' }}
                    selectContainerProps={{ width: 250 }}
                    hideSelectedItem={false}
                    onChange={(e) => {
                      onChange(e);
                      props.setModel({
                        ...props.model,
                        runType: e as string,
                      });
                    }}
                  />
                )}
              ></Controller>
              <FormErrorMessage>{errors.runType?.message}</FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Run Type of strategy execution
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isRequired isInvalid={!!errors.strategy} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Strategy Type :</FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='strategy'
                defaultValue={
                  props.model?.strategy?.split('|') || [
                    props.paramOptions.strategyTypeOptions[0],
                  ] || ['']
                }
                control={control}
                render={({ value }) => (
                  <Select
                    placeholder='Strategy Type'
                    options={props.paramOptions.strategyTypeOptions.map(
                      (val) => ({
                        label: val,
                        value: val,
                      }),
                    )}
                    defaultValues={value}
                    optionLabelProps={{ color: 'black' }}
                    selectContainerProps={{ width: 250 }}
                    showCheckboxes={true}
                    hideSelectedItem={false}
                    isMulti={true}
                    onChange={(e) => {
                      // onChange(e);
                      props.setModel({
                        ...props.model,
                        strategy:
                          typeof e == 'object' ? e.join('|') : (e as string),
                      });
                    }}
                  />
                )}
              ></Controller>
              <FormErrorMessage>{errors.strategy?.message}</FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Strategy that needs to be executed
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isRequired isInvalid={!!errors.serJsonDate} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>SER-Json FileDate : </FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='serJsonDate'
                defaultValue={props.model?.serJsonDate || ''}
                control={control}
                render={({ value, onChange }) => (
                  <DatePicker
                    onChange={(date, _dateString) => {
                      onChange(date?.format('YYYY-MM-DD'));
                      props.setModel({
                        ...props.model,
                        serJsonDate: date?.format('YYYY-MM-DD') || '',
                      });
                    }}
                    defaultValue={value ? dayjs(value) : undefined}
                    placeholder='SER-Json FileDate'
                    showToday={false}
                  />
                )}
              ></Controller>
              <FormErrorMessage>{errors.serJsonDate?.message}</FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Strategy SerJsonFileDate date in the format YYYY-MM-DD
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isRequired isInvalid={!!errors.executionDate} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Execution Date : </FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='executionDate'
                defaultValue={props.model?.executionDate || ''}
                control={control}
                render={({ value, onChange }) => (
                  <DatePicker
                    onChange={(date, _dateString) => {
                      onChange(date?.format('YYYY-MM-DD'));
                      props.setModel({
                        ...props.model,
                        executionDate: date?.format('YYYY-MM-DD'),
                      });
                    }}
                    defaultValue={value ? dayjs(value) : undefined}
                    placeholder='Execution Date'
                  />
                )}
              ></Controller>
              <FormErrorMessage>
                {errors.executionDate?.message}
              </FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Specify the date on when the Strategy to be executed date in the
                format YYYY-MM-DD
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isRequired isInvalid={!!errors.executionDate} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Sample Percentage : </FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='samplePercentage'
                defaultValue={props.model?.samplePercentage || '100'}
                control={control}
                render={({ value, onChange }) => (
                  <Input
                    size='sm'
                    onChange={(e) => {
                      onChange(e.target.value);
                      props.setModel({
                        ...props.model,
                        samplePercentage: e.target.value,
                      });
                    }}
                    disabled
                    value={value}
                    defaultValue={props.model?.samplePercentage}
                    spellCheck={false}
                  />
                )}
              ></Controller>
              <FormErrorMessage>
                {errors.samplePercentage?.message}
              </FormErrorMessage>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
    </>
  );
};

export const commonOptionalParams = (props: ParameterProps) => {
  const { errors, control } = props.formMethods;

  return (
    <>
      <Box>
        <FormControl isInvalid={!!errors.executeOnDemand} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Execute strategy on-demand : </FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='executeOnDemand'
                defaultValue={props.model?.executeOnDemand || 'N'}
                control={control}
                render={({ value, onChange }) => (
                  <Select
                    options={['Y', 'N'].map((val) => ({
                      label: val,
                      value: val,
                    }))}
                    defaultValue={value}
                    optionLabelProps={{ color: 'black' }}
                    selectContainerProps={{ width: 250 }}
                    // placeholder='Y'
                    onChange={(e) => {
                      onChange(e);
                      props.setModel({
                        ...props.model,
                        executeOnDemand: e as string,
                      });
                    }}
                  />
                )}
              ></Controller>
              <FormErrorMessage>
                {errors.executeOnDemand?.message}
              </FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Set this to Y if strategy needs to be executed immediately and
                set execution date as current date
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isInvalid={!!errors.consolidatedInputFileDate} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Consolidated Input FileDate : </FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='consolidatedInputFileDate'
                defaultValue={props.model?.consolidatedInputFileDate || ''}
                control={control}
                render={({ value, onChange }) => (
                  <DatePicker
                    onChange={(date, _dateString) => {
                      onChange(date?.format('YYYY-MM-DD') || '');
                      props.setModel({
                        ...props.model,
                        consolidatedInputFileDate:
                          date?.format('YYYY-MM-DD') || '',
                      });
                    }}
                    defaultValue={value ? dayjs(value) : undefined}
                    placeholder='Consolidated Input FileDate'
                  />
                )}
              ></Controller>
              <FormErrorMessage>
                {errors.consolidatedInputFileDate?.message}
              </FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Input the date for the consumer file to be used in the format
                YYYY-MM-DD
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isInvalid={!!errors.bureauFileDate} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Bureau FileDate : </FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='bureauFileDate'
                defaultValue={props.model?.bureauFileDate || ''}
                control={control}
                render={({ value, onChange }) => (
                  <DatePicker
                    onChange={(date, _dateString) => {
                      onChange(date?.format('YYYY-MM-DD') || '');
                      props.setModel({
                        ...props.model,
                        bureauFileDate: date?.format('YYYY-MM-DD') || '',
                      });
                    }}
                    defaultValue={value ? dayjs(value) : undefined}
                    placeholder='Bureau File Date'
                  />
                )}
              ></Controller>
              <FormErrorMessage>
                {errors.bureauFileDate?.message}
              </FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Bureau FileDate to be used in the format YYYY-MM-DD
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isInvalid={!!errors.generateArtifacts} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Generate artifacts</FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='generateArtifacts'
                defaultValue={props.model?.generateArtifacts || 'N'}
                control={control}
                render={({ value, onChange }) => (
                  <Select
                    options={['Y', 'N'].map((val) => ({
                      label: val,
                      value: val,
                    }))}
                    defaultValue={value}
                    optionLabelProps={{ color: 'black' }}
                    selectContainerProps={{ width: 250 }}
                    // placeholder='Y'
                    onChange={(e) => {
                      onChange(e);
                      props.setModel({
                        ...props.model,
                        generateArtifacts: e as string,
                      });
                    }}
                  />
                )}
              ></Controller>
              <FormErrorMessage>
                {errors.generateArtifacts?.message}
              </FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Updated artifacts based on updated Data dictionary
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
      <Box>
        <FormControl isInvalid={!!errors.spcFlag} mb={6}>
          <Grid templateColumns='repeat(4,1fr)'>
            <GridItem justifyContent='end' display='flex'>
              <FormLabel>Execute SPC jobs</FormLabel>
            </GridItem>
            <GridItem colSpan={3}>
              <Controller
                name='spcFlag'
                defaultValue={props.model?.spcFlag || 'Y'}
                control={control}
                render={({ value, onChange }) => (
                  <Select
                    options={['Y', 'N'].map((val) => ({
                      label: val,
                      value: val,
                    }))}
                    defaultValue={value}
                    optionLabelProps={{ color: 'black' }}
                    selectContainerProps={{ width: 250 }}
                    // placeholder='Y'
                    onChange={(e) => {
                      onChange(e);
                      props.setModel({
                        ...props.model,
                        spcFlag: e as string,
                      });
                    }}
                  />
                )}
              ></Controller>
              <FormErrorMessage>{errors.spcFlag?.message}</FormErrorMessage>
              <FormHelperText fontSize='xs'>
                Set this to N if SPC job execution is not required
              </FormHelperText>
            </GridItem>
          </Grid>
        </FormControl>
      </Box>
    </>
  );
};
